import './App.css';
import { Provider } from 'react-redux';
import { store } from './app/store';
import RouteFile from "./Routes/RouteFile";
import './styles/globals.css'
import 'bootstrap/dist/css/bootstrap.css'
import '@fortawesome/fontawesome-free/css/all.css'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (<Provider store={store}>
    <div className="App">
      <ToastContainer />
        <RouteFile />
    </div>
  </Provider>)
}

export default App;
